import React from 'react';
import Loader from '@/components/ui/Loader';
import Image from '@/components/ui/media/Image';
import { getPageMetadataComp } from '@/utils/metadata';
import { IMAGE_URL, ZUDDL_LOGO_COLORED } from '@/config';
import styles from './styles.module.scss';

const LandingPageLoader = ({ event = {} }: { event?: any }) => {
  const eventLogo =
    event && event.hasOwnProperty('logoUrl')
      ? event.logoUrl !== `${IMAGE_URL}` && !!event.logoUrl
        ? event.logoUrl
        : ZUDDL_LOGO_COLORED
      : null;
  const eventId = event?.eventId;

  return (
    <div className={styles.loadingContainer}>
      {eventLogo && (
        <div className={styles.imageContainer}>
          <Image src={eventLogo} />
        </div>
      )}
      {getPageMetadataComp({ eventId })}
      <div className={styles.loaderContainer}>
        <Loader />
        <div className={styles.loadingText}>Loading, please wait...</div>
      </div>
    </div>
  );
};

export default LandingPageLoader;
